export const DATA_LOAD_START = 'DATA_LOAD_START';
export const DATA_LOAD_DONE = 'DATA_LOAD_DONE';
export const DATA_LOAD_FAIL = 'DATA_LOAD_FAIL';

export const CURRENT_DATA_LOAD_START = 'CURRENT_DATA_LOAD_START';
export const CURRENT_DATA_LOAD_DONE = 'CURRENT_DATA_LOAD_DONE';
export const CURRENT_DATA_LOAD_FAIL = 'CURRENT_DATA_LOAD_FAIL';

export const HOVER_POI = "HOVER_POI";

